module.exports = __webpack_public_path__ + "static/media/roxy3.bfacb619.jpg";